import $ from 'jquery';

import generateFacilityBlock from './generateFacilityBlock';

const renderFacility = (dataArray) => {
	let blockHtml = '';
	$.each(dataArray, (index, facility) => {
		blockHtml += generateFacilityBlock(facility);
	});
	$('.section-block.-facilities > .content').html(blockHtml);
};

export default renderFacility;



// WEBPACK FOOTER //
// ./src/js/facilities/renderFacility.js